import $ from 'jquery';
import Validation from '../../common/utils/validation';
import fbfsCookie from '../utils/cookie';

class ModalChangeLocation {
    init() {
        this.bindEvents();
    }

    bindEvents() {
        $('.js-change-location').on('click', (e) => {
            e.preventDefault();
            let zipCode = $('#ZipCodeLocation').val();

            if (Validation.zipValidate($('#ZipCodeLocation'))) {
                // Set Zipcode cookie
                fbfsCookie.setCookie('zipcode', zipCode);

                // Make an API call to get state from zipcode and set cookie
                $.ajax({
                    url: `/api/state/${zipCode}`,
                    success: (result) => {
                        //console.log(result);
                        fbfsCookie.setCookie('state', result);
                        $.ajax({
                            url: `/api/country/${zipCode}`,
                            success: (result) => {
                                //console.log(result);
                                fbfsCookie.setCookie('country', result);
                            },
                            complete: () => {
                                //after completed request then this method will be called.
                                // Update zip code in various places
                                $('.js-footer-zipcode, .js-agent-advisor-zipcode').html(zipCode);
                                $('.js-agent-zipcode').val(zipCode);

                                // Close Modal
                                $('.js-inline-modal').modaal('close');
                                // Hide error
                                $('.js-footer-location-error').fadeOut();
                                $('#ZipCodeLocation').attr('aria-invalid', 'false');
                                window.location.reload();
                            },
                        });
                    }
                });
                //---/ Make an API call to get state from zipcode and set cookie

                // Make an API call to get state from country and set cookie
                //---/ Make an API call to get state from country and set cookie
            } else {
                // Error message
                $('.js-footer-location-error').fadeIn();
                $('#ZipCodeLocation').attr('aria-invalid', 'true');
                $('#ZipCodeLocation').focus();
            }
        });
    }
}

export default ModalChangeLocation;

$(() => {
    const modalChangeLocation = new ModalChangeLocation();
    modalChangeLocation.init();
});